import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import { AddIcon, CloseIcon } from '@sketchnote/icons';
import { Button } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

import { useAgileStore } from '../../store';

function CreateEpic() {
  const [epicName, setEpicName] = useState('');
  const [epicDescription, setEpicDescription] = useState('');
  const { addEpic } = useAgileStore((s) => ({ addEpic: s.addEpic }));
  const [isSaving, setSaving] = useState(false);
  const [errors, setErrors] = useState({ name: '', description: '' });

  const { isOpen, onClose, onOpen } = useDisclosure();
  const [open] = useSnackbar();
  const router = useRouter();
  const fileRef = router?.query?.slug as string;

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleEpicNameChange = (event) => {
    setEpicName(event.target.value);
    if (errors.name) {
      setErrors({ ...errors, name: '' });
    }
  };
  const handleEpicDescriptionChange = (event) => {
    setEpicDescription(event.target.value);
  };

  const handleCreateEpic = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    if (epicName.trim() === '') {
      setErrors({ ...errors, name: 'Epic name is required' });
      return;
    }
    setSaving(true);
    const epic = {
      name: epicName,
      description: epicDescription,
      fileId: fileRef,
    };
    const success = await addEpic(epic);
    if (success) {
      open({
        text: 'Epic created successfully!',
        duration: 2000,
        position: 'top-center',
        snackType: 'standard',
      });
      onClose();
    } else {
      open({
        text: 'Epic creation failed',
        duration: 2000,
        position: 'top-center',
        snackType: 'error',
      });
    }
    setSaving(false);
  };

  return (
    <>
      <Button status="secondary" onClick={onOpen} className="h-36 mt-3 mr-8 ">
        <span className="block">
          <AddIcon size={12} wrapperClass="mt-2 mr-2" /> New epic
        </span>
      </Button>
      <Portal>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            style={{
              position: 'initial',
              margin: '80px',
            }}
            className={` min-w-356 bg-white rounded-lg static`}
          >
            <div className="p-24">
              <div className="flex justify-between mb-8">
                <span className="text-primary-700 font-semibold text-xl">Create an Epic</span>
                <button aria-label="close button" onClick={onClose}>
                  <CloseIcon className="text-gray-600 text-xs" />
                </button>
              </div>

              <p className="mb-2 text-sm font-regular leading-22">
                Give your epic a name and description here. You can add the remaining details later.
              </p>
              <form onSubmit={handleCreateEpic}>
                <div className="w-full mb-20">
                  <label className="mb-8 block text-sm text-gray-500 font-medium">Epic Name</label>
                  <input
                    onChange={handleEpicNameChange}
                    type="text"
                    ref={inputRef}
                    className="border w-full text-base placeholder-text-gray-500 focus:shadow-outline border-gray-200 px-12 py-10 bg-gray-100 rounded-lg placeholder-text-base"
                  />
                  {!!errors.name && (
                    <label className="mb-8 block text-sm text-red-600 font-medium">
                      {errors.name}
                    </label>
                  )}
                </div>
                <div className="w-full mb-20">
                  <label className="mb-8 block  text-sm text-gray-500 font-medium">
                    Description
                  </label>
                  <textarea
                    onChange={handleEpicDescriptionChange}
                    className="border w-full text-base placeholder-text-gray-500 focus:shadow-outline border-gray-200 px-12 py-10 bg-gray-100 rounded-lg placeholder-text-base"
                  />
                </div>

                <div className="flex justify-start  w-full">
                  <button
                    className={` text-white border rounded-sm px-24 py-8  w-full ${
                      isSaving ? 'bg-blue-200' : 'bg-blue-500'
                    }`}
                    type="submit"
                  >
                    Create Epic
                  </button>
                </div>
              </form>
            </div>
            <ModalCloseButton />
          </ModalContent>
        </Modal>
      </Portal>
    </>
  );
}

export default CreateEpic;
